module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/003dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "acknowledgments"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/004acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "foreword"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007introduction"
    }
  }, [_vm._v("Introduction: The Road to Deliciousness")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter1"
    }
  }, [_vm._v("01 A Short Gluten-Free Baking Primer: Know Your Ingredients and Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2"
    }
  }, [_vm._v("02 Cookies")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_3"
    }
  }, [_vm._v("Speculaas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_4"
    }
  }, [_vm._v("Lebkuchen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_5"
    }
  }, [_vm._v("Pfeffernuesse")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_6"
    }
  }, [_vm._v("Springerle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_7"
    }
  }, [_vm._v("Pepparkakor")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_8"
    }
  }, [_vm._v("Rugelach")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_9"
    }
  }, [_vm._v("Benne Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_10"
    }
  }, [_vm._v("Fortune Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_11"
    }
  }, [_vm._v("Mexican Wedding Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_12"
    }
  }, [_vm._v("Spritz Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_13"
    }
  }, [_vm._v("Shortbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_14"
    }
  }, [_vm._v("Candy Cane Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_15"
    }
  }, [_vm._v("Cutout Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_16"
    }
  }, [_vm._v("Thumbprint Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_17"
    }
  }, [_vm._v("Gingerbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_18"
    }
  }, [_vm._v("Chocolate Chip Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_19"
    }
  }, [_vm._v("Chocolate Chip Meringues")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_20"
    }
  }, [_vm._v("Meringue Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_21"
    }
  }, [_vm._v("Chocolate-Cherry Biscotti")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_22"
    }
  }, [_vm._v("Lemon Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter2#sect_23"
    }
  }, [_vm._v("Gingerbread House")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3"
    }
  }, [_vm._v("03 Cakes")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_24"
    }
  }, [_vm._v("Genoise")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_25"
    }
  }, [_vm._v("Bûche De Noël")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_26"
    }
  }, [_vm._v("Fruitcake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_27"
    }
  }, [_vm._v("Cranberry Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_28"
    }
  }, [_vm._v("Gingerbread Cake With Persimmon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_29"
    }
  }, [_vm._v("Chocolate-Mandarin Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_30"
    }
  }, [_vm._v("Orange-Scented Olive Oil Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_31"
    }
  }, [_vm._v("King Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_32"
    }
  }, [_vm._v("Pound Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_33"
    }
  }, [_vm._v("Trifle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_34"
    }
  }, [_vm._v("Toasted Pecan Snack Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter3#sect_35"
    }
  }, [_vm._v("Steamed Plum Pudding")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4"
    }
  }, [_vm._v("04 Pies & Tarts")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_36"
    }
  }, [_vm._v("Pumpkin Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_37"
    }
  }, [_vm._v("Apple-Cinnamon Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_38"
    }
  }, [_vm._v("Maple-Pecan Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_39"
    }
  }, [_vm._v("Chocolate-Sunflower Butter Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_40"
    }
  }, [_vm._v("Mincemeat Tarts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter4#sect_41"
    }
  }, [_vm._v("Flaky Pie Crust")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5"
    }
  }, [_vm._v("05 Breads & Crackers")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_42"
    }
  }, [_vm._v("Simple Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_43"
    }
  }, [_vm._v("St. Lucia Buns")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_44"
    }
  }, [_vm._v("Applesauce Spice Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_45"
    }
  }, [_vm._v("Cinnamon Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_46"
    }
  }, [_vm._v("Dinner Rolls")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_47"
    }
  }, [_vm._v("Featherlight Buttermilk Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_48"
    }
  }, [_vm._v("Skillet Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_49"
    }
  }, [_vm._v("Soft Sandwich Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_50"
    }
  }, [_vm._v("Date Nut Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_51"
    }
  }, [_vm._v("Panettone")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_52"
    }
  }, [_vm._v("Stollen")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_53"
    }
  }, [_vm._v("Cheese Crackers And Straws")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter5#sect_54"
    }
  }, [_vm._v("Stuffing Like Mama Made")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6"
    }
  }, [_vm._v("06 Deep-Fried Treats")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_55"
    }
  }, [_vm._v("Pumpkin Doughnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_56"
    }
  }, [_vm._v("Sufganiyot (Jelly Doughnuts)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_57"
    }
  }, [_vm._v("PIzzelles")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_58"
    }
  }, [_vm._v("Krumkake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_59"
    }
  }, [_vm._v("Rosettes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_60"
    }
  }, [_vm._v("Struffoli")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_61"
    }
  }, [_vm._v("Buñuelos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sect62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter6#sect_62"
    }
  }, [_vm._v("Cannoli")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sourcesforingredientsequipment"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014sourcesforingredientsequipment"
    }
  }, [_vm._v("Sources For Ingredients & Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/016abouttheauthor"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/017copyright"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('img', {
    attrs: {
      "alt": "image3",
      "src": "images/image-003.jpg",
      "width": "100%"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e955eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-toc.vue
// module id = 69
// module chunks = 0